import * as React from 'react'
import { Component } from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'
import Slider from 'react-slick'
import { StoreProps } from 'src/stores'

interface State {
  autoplaySpeed: number
}

export default class SideBarSlider extends Component<StoreProps, State> {
  times = []

  constructor(props) {
    super(props)
    this.state = { autoplaySpeed: 2500 }
    this.generateTimes()
  }

  generateTimes = () => {
    for (let i = 0; i <= 10; i++) {
      this.times.push('vor ' + (Math.floor(Math.random() * 20) + 1) + ' min')
    }
  }

  randomTime = () => {
    const newTime = Math.floor(Math.random() * 3000) + 3000
    this.setState({ autoplaySpeed: newTime })
  }

  render() {
    const { autoplaySpeed } = this.state
    const settings = {
      arrows: false,
      slidesToShow: 2,
      infinite: true,
      autoplay: true,
      variableWidth: true,
      autoplaySpeed: autoplaySpeed,
      rtl: true,
      swipe: false,
      draggable: false,
      adaptiveHeight: true
    }
    const date = new Date()
    const stringDate =
      date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
    return (
      <Container>
        <h2>Kürzliche erstellte Planungen:</h2>
        <CustomSlider afterChange={this.randomTime} {...settings}>
          <div className='slide'>
            <p>Erdbestattung in 1180</p>
            <i className='date'>
              {stringDate} {this.times[0]}
            </i>
          </div>
          <div className='slide'>
            <p>Feuerbestattung in 8036</p>
            <i className='date'>
              {stringDate} {this.times[1]}
            </i>
          </div>
          <div className='slide'>
            <p>Donaubestattung in 1220</p>
            <i className='date'>
              {stringDate} {this.times[2]}
            </i>
          </div>
          <div className='slide'>
            <p>Baumbestattung in 5020</p>
            <i className='date'>
              {stringDate} {this.times[3]}
            </i>
          </div>
          <div className='slide'>
            <p>Erdbestattung in 9241</p>
            <i className='date'>
              {stringDate} {this.times[4]}
            </i>
          </div>
          <div className='slide'>
            <p>Baumbestattung in 7400</p>
            <i className='date'>
              {stringDate} {this.times[5]}
            </i>
          </div>
          <div className='slide'>
            <p>Feuerbestattung in 6020</p>
            <i className='date'>
              {stringDate} {this.times[6]}
            </i>
          </div>
          <div className='slide'>
            <p>Baumbestattung in 4020</p>
            <i className='date'>
              {stringDate} {this.times[7]}
            </i>
          </div>
          <div className='slide'>
            <p>Erdbestattung in 1090</p>
            <i className='date'>
              {stringDate} {this.times[8]}
            </i>
          </div>
          <div className='slide'>
            <p>Erdbestattung in 1040</p>
            <i className='date'>
              {stringDate} {this.times[9]}
            </i>
          </div>
        </CustomSlider>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  overflow: hidden;

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  ${media.giant`
    flex-direction: column;
    h2 {
      margin-bottom: 15px;
      text-align: center;
    }
  `}
`

const CustomSlider = styled(Slider)`
  width: 60%;

  .slick-slide > div {
    margin-right: 7.5px;
  }

  .slide {
    padding: 7.5px 15px;
    background: white;
    border-left: 3px solid #9abbbf;
    line-height: 1;

    p {
      margin: 0;
    }
    .date {
      font-size: 11px;
      text-transform: italic;
      margin: 0;
      margin-left: 3px;
    }
  }

  .slide:focus {
    outline: none;
  }

  ${media.giant`
    width: 100%;
  `}
`



// WEBPACK FOOTER //
// ./src/components/molecules/wizard/FakePlanningSlider.tsx